// extracted by mini-css-extract-plugin
export default {"app":"App_app__GQ97N","disclaimer":"App_disclaimer__HSvz0","eyebrow":"App_eyebrow__2fPqe","message":"App_message__Bt7xW"};